"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.environment = {
    production: true,
    apiBaseUrl: "https://wickedlist.com",
    name: "PRODUCTION"
};
